import type { RuleGroupType, RuleType } from 'react-querybuilder';

import type { LeadSegmentCondition, LeadSegmentConditionGroup } from './types';

export function queryToLeadSegmentConditionsTransformer(query: RuleGroupType): LeadSegmentConditionGroup {
  return {
    condition_group_operator_id: query.combinator,
    conditions: query.rules.map(mapRuleToLeadSegmentRule),
  };
}

function mapRuleToLeadSegmentRule(rule: RuleGroupType | RuleType): LeadSegmentCondition {
  if ('rules' in rule) {
    return {
      condition_group_operator_id: rule.combinator,
      conditions: rule.rules.map(mapRuleToLeadSegmentRule),
    };
  }

  return {
    attribute_id: rule.field,
    operator_id: rule.operator,
    value_id: 'isPredefinedValue' in rule && rule.isPredefinedValue ? rule.value : undefined,
    value: 'isPredefinedValue' in rule && rule.isPredefinedValue ? undefined : rule.value,
  };
}
